import React, { forwardRef, useContext, useEffect, useState } from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import Tooltip from '@mui/material/Tooltip';
import HomeIcon from '@mui/icons-material/Home';

import logo from '../../image/logo.svg'
import logoBlack from '../../image/logoBlack.png'
import patter from '../../image/patterColorido.svg'

import '../Header/style.css'
import { IconButton } from '@mui/material';
import { atendimetoWhatsapp } from '../../function';
import { ThemeContext } from '../../contexts/theme-context';

function HeaderSafe({history}) {
    const { theme } = useContext(ThemeContext);
    const WhatsApp = forwardRef(function MyComponent(props, ref) {
        return (
            <div {...props} ref={ref}>
                <HelpOutlineIcon
                className="iconCenter"
                style={{
                    width: 30,
                    height: 50,
                    marginRight: 20
                }}/>
            </div>
        );
    });
    const Faq = forwardRef(function MyComponent(props, ref) {
        return (
            <div {...props} ref={ref}>
                <HeadsetMicIcon 
                    className="iconCenter"
                    style={{
                        width: 30,
                        height: 50,
                        marginRight: 20
                    }}
                    />
            </div>
        );
    });
    const Home = forwardRef(function MyComponent(props, ref) {
        return (
            <div {...props} ref={ref}>
                <HomeIcon 
                    className="iconCenter"
                    style={{
   
                        width: 30,
                        height: 50
                    }}
                    />
            </div>
        );
    });
    const newAttendance = async () => {
        let msg = "Olá Grupo Urbam";
        atendimetoWhatsapp(msg);
    }
    const fac = async () => {
        let url =  "https://www.grupourbam.com.br/faq";
        window.open(url, '_blank', 'noreferrer');
    }
    useEffect(() => {
        // setInterval(myTimer ,1000)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    let [relogio, setRelogio] = useState();  
    let [saudacao, setSaudacao] = useState();  
    function myTimer() {
        var d = new Date(), displayDate;
        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            displayDate = d.toLocaleDateString('pt-BR', {timeZone: 'America/Belem'}) + " " + d.toLocaleTimeString('pt-BR');
        } else {
            displayDate = d.toLocaleDateString('pt-BR', {timeZone: 'America/Belem'}) + " " + d.toLocaleTimeString('pt-BR', {timeZone: 'America/Belem'});
        }
       setRelogio(displayDate);
       greetingMessage(d)
    }
    const greetingMessage = (d) => {
        let h = new Date().getHours();
        if (h < 12){
            setSaudacao('Bom dia')
        }else{
            if (h < 18) {
                setSaudacao('Boa tarde')
            }else{
                setSaudacao('Boa noite');
            }
        }
    }
    return (
        <>
            <Navbar className='nav' expand="lg"  variant="dark" fixed="top">
                <Container>
                    <div style={{
                        marginLeft: 35, 
                        }}>
                        <Navbar.Brand>
                            <img
                            src={theme !== 'dark' ? logo : logoBlack}
                            height="52"
                            className="d-inline-block align-top"
                            alt="Grupo Urbam Logo"
                            />
                        </Navbar.Brand>
                    </div>
                </Container>
            </Navbar>
            <Navbar className='nav2' expand="lg" style={{padding: 0, top: 84}} sticky="top">
                <div className='box backgroundPatter'>
                    <div className='saudacao'>{saudacao}</div>
                    <div className='dataHora'>{relogio}</div>
                    <div style={{
                        height: 50,
                        position: "absolute",
                        width: "100%",
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <Tooltip title="FAQ">
                            <WhatsApp onClick={() => fac()} />
                        </Tooltip>
                        <Tooltip title="Atendimento" onClick={() => newAttendance()}>
                            <Faq />
                        </Tooltip>
                        <Tooltip title="Home" onClick={() =>  history.push('login')}>
                            <Home />
                        </Tooltip>
                    </div>
                </div>
                <Navbar.Collapse className="justify-content-end">
                    <Navbar.Text>
                        <img
                        src={patter}
                        className="d-inline-block align-top patterInvert"
                        style={{height: 60}}
                        alt="Patter"
                        />
                    </Navbar.Text>
                </Navbar.Collapse>
            </Navbar>
        </>
    );
}

export default HeaderSafe;